import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let H3Scroll = class H3Scroll extends Vue {
    constructor() {
        super(...arguments);
        this.mescroll = null;
    }
    get isBPMLite() {
        return window.location.hash.indexOf("/bpmLite/") > -1 ? true : false;
    }
    mounted() {
        const langu = window.localStorage.getItem("locale");
        const MeScroll = require("mescroll.js");
        // ;
        const self = this;
        self.mescroll = new MeScroll(`${this.wrapId}`, {
            up: {
                auto: this.autoUp,
                use: this.enableUp,
                page: { size: self.pageSize },
                callback: self.upCallback,
                // 默认为可回弹，兼容ios 9.0
                isBounce: true,
                htmlLoading: `<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">${langu === 'en' ? (this.isBPMLite ? 'Loading..' : 'loading..') : '加载中..'}</p>`,
                htmlNodata: `<p class="upwarp-nodata">${langu === 'en' ? 'All data loaded' : '加载完毕'}</p>`,
                warpId: this.wrapId,
                isLock: this.isLock,
                onScroll: self.scroll,
            },
            down: {
                use: this.enableDown,
                auto: true,
                textOutOffset: `${langu === 'en' ? 'release update' : '更新'}`,
                textLoading: `${langu === 'en' ? (this.isBPMLite ? 'Loading..' : 'loading..') : '加载中..'}`,
            }
        });
        self.mescroll.lockUpScroll(this.isLock);
    }
    upCallback(page) {
        const self = this;
        if (self.loadMore) {
            self.loadMore(page, (length, total) => {
                self.mescroll.endBySize(length, total);
            }, () => {
                self.mescroll.endErr();
            });
        }
    }
};
tslib_1.__decorate([
    Prop({
        default: false
    })
], H3Scroll.prototype, "isLock", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], H3Scroll.prototype, "enableDown", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], H3Scroll.prototype, "enableUp", void 0);
tslib_1.__decorate([
    Prop()
], H3Scroll.prototype, "refresh", void 0);
tslib_1.__decorate([
    Prop()
], H3Scroll.prototype, "loadMore", void 0);
tslib_1.__decorate([
    Prop({
        default: 10
    })
], H3Scroll.prototype, "pageSize", void 0);
tslib_1.__decorate([
    Prop({
        default: '已加载全部数据'
    })
], H3Scroll.prototype, "noMoreMessage", void 0);
tslib_1.__decorate([
    Prop({
        default: 'list-scroller'
    })
], H3Scroll.prototype, "wrapId", void 0);
tslib_1.__decorate([
    Prop()
], H3Scroll.prototype, "scroll", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], H3Scroll.prototype, "autoUp", void 0);
H3Scroll = tslib_1.__decorate([
    Component({
        name: 'h3-scroll',
        components: {}
    })
], H3Scroll);
export default H3Scroll;
